import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  IconButton,
  InputBase,
  Paper,
  useMediaQuery,
} from "@mui/material";
import { Menu, MenuItem } from "@mui/material";
import EuroIcon from "@mui/icons-material/Euro"; // for Pay Now
import FilterListIcon from "@mui/icons-material/FilterList"; //
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomText, { textStyles } from "../../../../components/CustomText";
import ExportDropdown from "../../../../components/ExportDropdown";
import tablefilter from "../../../../assets/tablefilter.svg";
import StatusDropdown from "../../../../components/StatusDropdown";
import DownloadIcon from "@mui/icons-material/Download";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import tableicon from "../../../../assets/Dashboard/tableicon.svg";
import AddSalaryDrawer from "./AddSalaryDrawer";
import SalaryDetailsDrawer from "./SalaryRecordsDetails";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchInput from "../../../../components/SearchInput";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useTranslation } from "react-i18next";
const salaryData = [
  {
    id: "12321",
    workerName: "Jane Rotanson",
    amount: "$120",
    method: "Paypal",
    proof: true,
    status: "Paid",
    dateTime: "11 Apr, 2025 - 10:30 AM",
    comments: "-",
  },
  {
    id: "34234",
    workerName: "Jane Rotanson",
    amount: "$120",
    method: "Cheque",
    proof: true,
    status: "Paid",
    dateTime: "11 Apr, 2025 - 10:30 AM",
    comments: "-",
  },
  {
    id: "23423",
    workerName: "Michal Mike",
    amount: "$120",
    method: "Cash",
    proof: true,
    status: "Paid",
    dateTime: "11 Apr, 2025 - 10:30 AM",
    comments: "Half salary paid",
  },
  {
    id: "424",
    workerName: "Jane Rotanson",
    amount: "$120",
    method: "Stripe",
    proof: false,
    status: "Error",
    dateTime: "11 Apr, 2025 - 10:30 AM",
    comments: "Insufficient Balance",
  },
  {
    id: "2342423",
    workerName: "Lisa Michel",
    amount: "$120",
    method: "Bank Transfer",
    proof: true,
    status: "Paid",
    dateTime: "11 Apr, 2025 - 10:30 AM",
    comments: "Bonus is paid to you for your good work.",
  },
];

const statusStyles = {
  Paid: {
    bg: "#00C48C1A",
    color: "#00C48C",
    icon: <CheckCircleIcon sx={{ fontSize: 16 }} />,
  },
  Error: {
    bg: "#FF00001A",
    color: "#FF0000",
    icon: <ErrorOutlineIcon sx={{ fontSize: 16 }} />,
  },
};

const SalaryRecords = ({ noBorder = false }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t } = useTranslation();
  const [selectedIds, setSelectedIds] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const HaederStyles = {
    color: "#44546F",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    textAlign:"center",

  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
  };

  const handleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (label) => {
    alert(`${label} is under development`);
    handleClose();
  };
  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        py: 2,
        mt: 1.5,
        ml: 1,
        mr: 1,
        border: "2px solid #091E4224",
        ...(noBorder
          ? {
              py: 0,
              ml: 1,
              mr: 0,
              border: "none",
            } // If noBorder is true, apply nothing extra
          : {
              py: 2,
              mt: 1.5,
              ml: 1,
              mr: 1,
              border: "2px solid #091E4224",
            }),
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: isMobile ? "wrap" : "nowrap",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
              textAlign: "left",
            }}
          >
            {t("salaryManagement.manageSalary")}
          </CustomText>
        </Box>
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <SearchInput
            placeholder={t("salaryManagement.searchSlips")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>
        <Box
          sx={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}
        >
          <ExportDropdown />
          <Button
            variant="contained"
            onClick={() => setOpenDrawer(true)}
            size="small"
            sx={{
              px: 2,
              backgroundColor: "#006EC2",
              height: 32,
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Poppins, sans-serif",
              borderRadius: "4px",
              textTransform: "none",
            }}
            startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          >
            {t("salaryManagement.add")}
          </Button>
          {/* <img src={tableicon} width={30} height={30} style={{ cursor: 'pointer' }} /> */}
          <>
            <img
              src={tableicon}
              width={33}
              height={33}
              style={{ cursor: "pointer" }}
              onClick={handleClick}
            />

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 3,
                sx: {
                  mt: 1,
                  borderRadius: 2,
                  minWidth: 120,
                },
              }}
            >
              <MenuItem
                sx={{ fontSize: "14px", fontFamily: "Poppins, sans-serif" }}
                onClick={() => handleAction("Pay Now")}
              >
                <EuroIcon sx={{ fontSize: 14, mr: 1 }} />
                {t("salaryManagement.payNow")}
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: "Poppins, sans-serif", fontSize: "14px" }}
                onClick={() => handleAction("Filter")}
              >
                <FilterListIcon sx={{ fontSize: 14, mr: 1 }} />
                {t("salaryManagement.filter")}
              </MenuItem>
            </Menu>
          </>
        </Box>
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead sx={{ borderBottom: "2px solid #091E4224",
             whiteSpace: 'nowrap', // ✅ Prevent text wrap
    overflow: 'hidden',
    textOverflow: 'ellipsis'
           }}>
            <TableRow>
              {/* <TableCell padding="checkbox">
                <Checkbox size="small" />
              </TableCell> */}
              <TableCell sx={{...HaederStyles,pl:1}}>
                {t("salaryManagement.id")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.workerName")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.amount")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.method")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.proof")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.status")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.dateTime")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.comments")}
              </TableCell>
              <TableCell sx={HaederStyles}>
                {t("salaryManagement.action")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salaryData
              .filter((row) =>
                Object.values(row)
                  .join(" ")
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              )
              .map((row, i) => (
                <TableRow key={i}>
                  {/* <TableCell padding="checkbox">
                    <Checkbox
                      size="small"
                      checked={selectedIds.includes(row.id)}
                      onChange={() => handleSelect(row.id)}
                    />
                  </TableCell> */}
                  <TableCell sx={{...DataStyles,pl:1.5}}>{row.id}</TableCell>
                  <TableCell sx={DataStyles}>{row.workerName}</TableCell>
                  <TableCell sx={DataStyles}>{row.amount}</TableCell>
                  <TableCell sx={DataStyles}>{row.method}</TableCell>
                  <TableCell onClick={showUnderDevelopment}>
                    {row.proof ? (
                      <DownloadIcon
                        sx={{
                          color: "#007BFF",
                          fontSize: 18,
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell>
                    {/* <StatusDropdown
                     currentStatus={row.status}
                   /> */}
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown
                        currentStatus={row.status}
                        // onChange handler disabled
                      />
                    </Box>
                  </TableCell>
                  <TableCell sx={DataStyles}>{row.dateTime}</TableCell>
                  <TableCell sx={DataStyles}>{row.comments}</TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSelectedSalary(row);
                        setTimeout(() => setOpenDetails(true), 0);
                      }}
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        {[1].map((num, i) => (
          <Box
            key={i}
            sx={{
              px: 1.5,
              py: 0.6,
              borderRadius: 1,
              backgroundColor: num === 1 ? "#006EC2" : "#F4F4F4",
              color: num === 1 ? "#fff" : "#000",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            {num}
          </Box>
        ))}
      </Box>
      <AddSalaryDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
      <SalaryDetailsDrawer
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        data={selectedSalary}
      />
    </Box>
  );
};

export default SalaryRecords;
